import { useState } from 'react'
import { LoaderCircle, Mountain, Search } from 'lucide-react'
import { PlaceSearchError, searchPlaces } from '../lib/placeSearch'

// The route builder has had peak search since v0.6; this is the same search,
// packaged so the summit form and the expedition editor can use it too.
export default function PeakSearchField({ onChoose, hint }) {
  const [query, setQuery] = useState('')
  const [results, setResults] = useState([])
  const [error, setError] = useState('')
  const [searching, setSearching] = useState(false)
  const [chosenKey, setChosenKey] = useState('')

  async function run(event) {
    event.preventDefault()
    setSearching(true)
    setError('')
    setResults([])
    try {
      const found = await searchPlaces(query, 'peak')
      setResults(found)
      if (!found.length) setError('No peaks found. Add the country name, or type the details in by hand.')
    } catch (searchError) {
      setError(searchError instanceof PlaceSearchError
        ? searchError.message
        : 'Peak search is unavailable right now. You can still enter details manually.')
    } finally {
      setSearching(false)
    }
  }

  function choose(result) {
    setChosenKey(result.key)
    onChoose(result)
  }

  return (
    <div className="peak-search">
      <div className="peak-search__label"><Mountain size={14} /> Find a peak</div>
      {hint && <p className="peak-search__hint">{hint}</p>}

      <div className="place-search__bar">
        <Search size={15} />
        <input
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          onKeyDown={(event) => { if (event.key === 'Enter') run(event) }}
          placeholder="Triglav, Musala, Galdhøpiggen…"
          aria-label="Search for a peak"
        />
        <button type="button" className="primary-button" onClick={run} disabled={searching}>
          {searching ? <LoaderCircle className="spin" size={15} /> : 'Search'}
        </button>
      </div>

      {error && <p className="place-search__error">{error}</p>}

      {results.length > 0 && (
        <div className="place-results peak-search__results">
          {results.map((result) => (
            <button
              type="button"
              key={result.key}
              className={chosenKey === result.key ? 'selected' : ''}
              onClick={() => choose(result)}
            >
              <Mountain size={15} />
              <span>
                <strong>{result.label}</strong>
                <small>{[result.context, result.elevation ? `${result.elevation.toLocaleString()} m` : ''].filter(Boolean).join(' · ')}</small>
              </span>
            </button>
          ))}
        </div>
      )}

      <p className="place-attribution">Peak data © OpenStreetMap contributors, via Photon.</p>
    </div>
  )
}
